import React from 'react';
import { Zap, Lightbulb, Sparkles, Radio, FlashlightIcon, Package } from 'lucide-react';
import { products } from '../data/mockData';
import LightEffects from './LightEffects';

const iconMap = {
  'moving-head-beam': Zap,
  'wash': Lightbulb,
  'bsw': Sparkles,
  'lasers': Radio,
  'strobe': FlashlightIcon,
  'par-led': Lightbulb,
  'accessories': Package
};

const Products = () => {
  return (
    <section id="products" className="relative bg-black py-24 md:py-32">
      {/* Light Effects */}
      <LightEffects variant="lasers" />
      
      <div className="container mx-auto px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl md:text-6xl font-semibold text-white mb-6 tracking-tight">
            Our Products
          </h2>
          <div className="h-1 w-24 bg-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
            Discover our comprehensive range of professional lighting solutions, engineered in Germany for uncompromising performance and reliability.
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {products.map((product) => {
            const IconComponent = iconMap[product.category] || Zap;
            return (
              <div
                key={product.id}
                className="group relative bg-gradient-to-b from-white/5 to-transparent border border-white/10 overflow-hidden transition-all duration-500 hover:border-blue-500/50 hover:shadow-2xl hover:shadow-blue-500/20"
                style={{ borderRadius: '0px' }}
              >
                {/* Product Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  
                  {/* Icon Badge */}
                  <div className="absolute top-4 right-4 bg-blue-600 p-3">
                    <IconComponent size={24} className="text-white" />
                  </div>
                </div>

                {/* Product Info */}
                <div className="p-8">
                  <h3 className="text-2xl font-semibold text-white mb-4 tracking-tight">
                    {product.name}
                  </h3>
                  <p className="text-base text-white/70 mb-6 leading-relaxed">
                    {product.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 mb-6">
                    <p className="text-sm font-medium text-blue-400 uppercase tracking-wider">
                      Key Features
                    </p>
                    <ul className="space-y-2">
                      {product.features.slice(0, 3).map((feature, index) => (
                        <li key={index} className="text-sm text-white/60 flex items-center gap-2">
                          <span className="w-1.5 h-1.5 bg-blue-500"></span>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Applications */}
                  <div className="flex flex-wrap gap-2">
                    {product.applications.map((app, index) => (
                      <span
                        key={index}
                        className="text-xs px-3 py-1.5 bg-white/5 text-white/70 border border-white/10"
                      >
                        {app}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Hover Effect Line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-blue-500 transition-all duration-500 group-hover:w-full"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Products;
